import { render, staticRenderFns } from "./EliminarImg.vue?vue&type=template&id=aedcccee&"
import script from "./EliminarImg.vue?vue&type=script&lang=js&"
export * from "./EliminarImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports